<app-field-container [field]="this">
  <div class="form-check form-switch">
    <label class="form-check-label">
      <input
        type="checkbox"
        [formControl]="control"
        class="form-check-input" switch/>
      {{ valueLabel() }}
    </label>
  </div>
</app-field-container>
